import React, { useRef } from 'react';
import PrimaryNavLink from './primary-nav-link';
import SubNavLink from './sub-nav-link';
import useClickOutside from '../../../hooks/useClickOutside';

const NavDropdown = ({ triggerRef, isMounted, setIsMounted, mainItems, secondaryItems, secondaryLabel}) => {
  const dropdownRef = useRef(null);
  useClickOutside({ref: dropdownRef, triggerRef, setOpen: setIsMounted});

  return (
    <div ref={dropdownRef} className={`nav-dropdown ${isMounted ? 'mount' : 'unmount'}`}>
      <div className='nav-dropdown-main-links-wrapper'>
        {mainItems.map((item, index) => {
          const label = item.label;
          const link = item.uri;
          const image = item.menuIcons?.icon?.mediaItemUrl || undefined;
          const altText = item.menuIcons?.icon?.altText || undefined;

          return (
            <PrimaryNavLink key={index} label={label} link={link} image={image} altText={altText} id={''} />
          )
        })}
      </div>
      {secondaryItems &&
        <div className='nav-dropdown-secondary-links-wrapper'>
          <hr />
          <p className='secondary-label'>{secondaryLabel}</p>
          {secondaryItems.map((item, index) => {
            return (
              <SubNavLink key={index} item={item} />
            )
          })}
        </div>
      }
    </div>
  )
}

export default NavDropdown;
